import { useMemo } from "react";
import { useAppDispatch, useRootState } from "./index";
import { bindActionCreators } from "redux";
import {
  trunkGetWorkgroupList,
  trunkGetDeletedWorkgroupList,
  trunkChangeWorkgroupStatus,
  trunkGetWorkgroupDetail,
  trunkGetContentList,
  trunkDownloadContent,
  trunkChangeManager,
} from "../store/admin/adminWorkgroup";

const useAdminWorkgroupStore = () => {
  const adminWorkgroupStore = useRootState(
    (state) => state.adminWorkgroupStore
  );

  const dispatch = useAppDispatch();

  const boundGetWorkgroupList = useMemo(
    () => bindActionCreators(trunkGetWorkgroupList, dispatch),
    [dispatch]
  );
  const boundGetDeletedWorkgroupList = useMemo(
    () => bindActionCreators(trunkGetDeletedWorkgroupList, dispatch),
    [dispatch]
  );
  const boundChangeWorkgroupStatus = useMemo(
    () => bindActionCreators(trunkChangeWorkgroupStatus, dispatch),
    [dispatch]
  );
  const boundGetWorkgroupDetail = useMemo(
    () => bindActionCreators(trunkGetWorkgroupDetail, dispatch),
    [dispatch]
  );
  const boundGetContentList = useMemo(
    () => bindActionCreators(trunkGetContentList, dispatch),
    [dispatch]
  );
  const boundDownloadContent = useMemo(
    () => bindActionCreators(trunkDownloadContent, dispatch),
    [dispatch]
  );
  const boundChangeManager = useMemo(
    () => bindActionCreators(trunkChangeManager, dispatch),
    [dispatch]
  );
  return {
    adminWorkgroupStore,
    getWorkgroupList: boundGetWorkgroupList,
    getDeletedWorkgroupList: boundGetDeletedWorkgroupList,
    changeWorkgroupStatus: boundChangeWorkgroupStatus,
    getAdminWorkgroupDetail: boundGetWorkgroupDetail,
    getContentList: boundGetContentList,
    downloadContent: boundDownloadContent,
    changeManager: boundChangeManager,
  };
};

export default useAdminWorkgroupStore;
